import React from 'react'
import { useSelector } from 'react-redux'
import chmln from '@chamaeleonidae/chmln'
import { getUserSession } from 'helpers/getUserSession.helper'
import { canActiveChmln, canIdenetifyChmln, currentUserFormatted } from 'helpers/chameleon.helper'
import { IMainState } from 'store/states'

export function useChameleon() {
  const permission = useSelector((store: IMainState) => store.user.permission)

  React.useEffect(() => {
    if (permission.loading) return
    const currentUser: any = getUserSession()
    try {
      if (canActiveChmln() && canIdenetifyChmln(currentUser)) {
        chmln.identify(currentUser.token, {
          ...currentUserFormatted(currentUser),
          LMS: {
            admin: permission.admin,
            superadmin: permission.superadmin,
            supervisor: permission.supervisor,
            moderator: permission.moderator,
            permissions: permission.permissions,
          },
        })
      }
    } catch (error) {
      console.error('Chameleon init failed', error)
    }
  }, [permission])
}
